import styled from 'styled-components';
import { ButtonBase } from '../ButtonBase';

export const StyledSecondaryButton = styled(ButtonBase)`
  font-family: ${(props): string => props.theme.fonts.button};
  background-color: ${(props): string => props.theme.colors.white};
  color: ${(props): string => props.theme.colors.text};
  border: 2px solid ${(props): string => props.theme.colors.buttonBorder};
  border-radius: 0;
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  justify-content: center;

  :hover,
  :focus,
  :active {
    border-color: ${(props): string => props.theme.colors.text};
    background-color: ${(props): string => props.theme.colors.white};
    color: ${(props): string => props.theme.colors.text};
  }

  :hover {
    background-color: ${(props): string => props.theme.colors.buttonHover};
  }

  :focus {
    border: 2px solid ${(props): string => props.theme.colors.focusBorder};
  }

  :active {
    background-color: ${(props): string => props.theme.colors.text};
    color: ${(props): string => props.theme.colors.white};
  }

  :disabled,
  :disabled:hover {
    border-color: ${(props): string => props.theme.colors.semiGray};
    background-color: ${(props): string => props.theme.colors.white};
    color: rgba(${(props): string => props.theme.colors.textRgb}, 0.3);
  }

  &.button__size-s {
    height: auto;
    font-size: 13px;
    line-height: 17px;
    padding: 6px 12px 5px;
  }

  &.button__size-m {
    height: 44px;
    font-size: 15px;
    line-height: 19px;
    padding: 11px 11px 10px;
  }
`;
